import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  STORAGE_UPLOAD_BEGIN,
  STORAGE_UPLOAD_SUCCESS,
  STORAGE_UPLOAD_FAILURE,
  STORAGE_UPLOAD_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';

export function upload(container, arquivo, callback) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: STORAGE_UPLOAD_BEGIN,
    data: { container, arquivo },
    callback,
  };
}

export function dismissUploadError() {
  return {
    type: STORAGE_UPLOAD_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on STORAGE_GRAVAR_ARQUIVO_BEGIN actions
export function* doUpload(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  const ContainerApi = new Services['ContainerApi']();
  try {
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    res = yield ContainerApi.upload(action.data.container, action.data.arquivo);
  } catch (err) {
    yield put({
      type: STORAGE_UPLOAD_FAILURE,
      data: { error: err },
    });

    if (action.callback) {
      action.callback(STORAGE_UPLOAD_FAILURE, err);
    }
    return;
  }

  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: STORAGE_UPLOAD_SUCCESS,
    data: res,
  });

  if (action.callback) {
    action.callback(STORAGE_UPLOAD_SUCCESS, res);
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchUpload() {
  yield takeLatest(STORAGE_UPLOAD_BEGIN, doUpload);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case STORAGE_UPLOAD_BEGIN:
      return {
        ...state,
        uploadPending: true,
        uploadError: null,
      };

    case STORAGE_UPLOAD_SUCCESS:
      return {
        ...state,
        registros: { ...state.registros, ...action.data },
        uploadPending: false,
        uploadError: null,
      };

    case STORAGE_UPLOAD_FAILURE:
      return {
        ...state,
        uploadPending: false,
        uploadError: action.data.error,
      };

    case STORAGE_UPLOAD_DISMISS_ERROR:
      return {
        ...state,
        uploadError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/storage/redux/upload.js